import { useEffect, useState } from "react";
import Button from "../../../utils/components/Button";
import { Helmet } from "react-helmet-async";
import { withLocalize } from "react-localize-redux";
import { useOutletContext } from "react-router";
import UpdatePersonalInfoForm from "./UpdatePersonalInfoForm";

const PersonalInformation = ({ translate }) => {
  const [modalShow, setModalShow] = useState(false);
  const [personalInfo, setPersonalInfo] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const { setBreadcrumbs, userInfo, setUserInfo, updateUserData } =
    useOutletContext();

  useEffect(() => {
    if (userInfo) {
      const personalInfo = [
        {
          value: userInfo.name,
          id: "name",
        },
        {
          value: userInfo.title,
          id: "personal_title",
        },
        {
          value: userInfo.email,
          id: "email",
        },
        {
          value: userInfo.company?.name,
          id: "company",
        },
      ];

      setPersonalInfo(personalInfo);
    }
  }, [userInfo]);

  useEffect(() => {
    if (userInfo) {
      setBreadcrumbs([
        {
          id: 0,
          title: "page_titles.account",
          route: "auth.account",
        },
        { id: 1, customTitle: userInfo?.name || "" },
        {
          id: 2,
          title: "page_titles.account-info",
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  return (
    <div className="personal-information container">
      <Helmet>
        <title>{translate("page_titles.account-info")}</title>
      </Helmet>
      <div className="row pt-5 pb-4 border-bottom border-dark">
        <div className="col-12 d-flex flex-wrap align-items-center justify-content-between">
          <p className="fs-4 mb-0">{translate("page_titles.account-info")}</p>
          <Button
            className="btn-gray text-white"
            onClick={() => setModalShow(true)}
          >
            {translate("update")}
          </Button>
        </div>
      </div>
      <div className="row">
        {personalInfo.map((item, index) => (
          <div className="col-12 col-md-6 text-center mt-4" key={index}>
            <p className="mb-1">{translate(item.id)}</p>
            <p className="fw-bold text-dark">{item.value}</p>
          </div>
        ))}
      </div>
      <UpdatePersonalInfoForm
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        modalShow={modalShow}
        setModalShow={setModalShow}
        translate={translate}
        updateUserData={updateUserData}
      />
    </div>
  );
};

export default withLocalize(PersonalInformation);
